import { Component, OnInit } from "@angular/core";
import { ConfirmModalService } from "@shared/services/confirm-modal.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { take } from "rxjs";

@Component({
	selector: "app-modal",
	templateUrl: "./modal.component.html",
	styleUrls: ["./modal.component.scss"],
	standalone: false
})
export class ModalComponent implements OnInit {
	status = false;
	title = "";
	body = "";
	size = "modal-md";
	primaryButton = "";
	secondaryButton = "";
	showWarningIcon = false;
	isUnsavedChangesModal = false;
	isHighRisk = false;
	isDisabledBtnDeleteHighRisk = true;

	constructor(
		private bsModalRef: BsModalRef,
		private confirmModalService: ConfirmModalService
	) {}

	loading$ = this.confirmModalService.status$;

	ngOnInit(): void {
		this.bsModalRef.setClass(this.size);

		this.bsModalRef.onHidden
			?.pipe(take(1))
			.subscribe(() =>
				this.confirmModalService.setNewStatus(this.status)
			);
	}

	hide(): void {
		this.confirmModalService.setNewStatus(this.status);
		this.bsModalRef.hide();
	}

	confirm(): void {
		this.status = this.isUnsavedChangesModal ? false : true;
		this.hide();
	}

	decline(): void {
		this.status = this.isUnsavedChangesModal ? true : false;
		this.hide();
	}

	confirmDelete(): void {
		this.status = this.isUnsavedChangesModal ? false : true;
		this.hide();
	}

	changeStateBtnDeleteHighRisk(event: EventTarget | null): void {
		this.isDisabledBtnDeleteHighRisk = !(<HTMLInputElement>event).checked;
	}
}
